import Vue from 'vue'
import VueRouter from 'vue-router'
const routesBase = require('./routesBase')
const routesCustom = require('./routesCustom')
const routesRistorazione = require('./routesRistorazione')
const routesCassa = require('./routesCassa')
const routesDiretti = require('./routesDiretti')
const routesServizio = require('./routesServizio')
const routesConfigurazione = require('./routesConfigurazione')
const routesGestione = require('./routesGestione')

Vue.use(VueRouter)

let routes = [
  ...routesBase.routes,
  ...routesCustom.routes,
  ...routesServizio.routes,
  ...routesRistorazione.routes,
  ...routesDiretti.routes,
  ...routesConfigurazione.routes,
  ...routesCassa.routes,
  ...routesGestione.routes,
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard') // TODO: Prevedere la 404
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

/* Per LOGIN
router.beforeEach(async (to, from, next) => {
  const { authorize } = to.meta;
  const currentUser = store.getters['utenti/user']
  if (authorize) {
    if (!currentUser) {
        return next({ path: '/login', query: { returnUrl: to.path } });
    }
    if (authorize.length && !_.intersection(authorize, currentUser.roles).length) {
        return next({ path: '/' });
    }
  }
  next()
})
*/

// https://stackoverflow.com/questions/50633001/vuejs-vue-router-linking-an-external-website
// Override matcher to fix external links.
const match = router.matcher.match
router.matcher.match = (...args) => {
  let route = match.apply(router, args)
  if (!route.meta.external) {
    return route
  }
  if (route.params && route.params.source) {
    return Object.freeze({...route, fullPath: route.params.source})
  } else {
    return Object.freeze({...route, fullPath: route.path})
  }
}

// Override resolver to fix external links.
const resolve = router.resolve
router.resolve = (...args) => {
  const resolved = resolve.apply(router, args)
  if (resolved.route.meta.external) {
    resolved.href = resolved.route.fullPath
  }
  return resolved
}

// Handle external routes.
router.beforeEach((to, from, next) => {
  if (to.meta.external) {
    if (to.meta.newWindow || to.params.newWindow) {
      window.open(to.fullPath)
    }
    else {
      window.location.replace(to.fullPath)
    }
    return next(false)
  }
  if (!to.meta.layout) {
    to.meta.layout = 'Default'
  }
  next()
})

export default router
